import { E2E_CONSTANTS } from '@avalara/bat-apps-shared/constants';
import env from '../shared/env';

const { AvaAppConfig, appEnv } = window;

// The purpose of this function is to map AvaApp config string to local Buydot config string.
// It will always return env string that can be utilized by Buydot. Default can be overridden by argEnv param.
// AvaApp returns env that is of type 'local' | 'dev' | 'qa' | 'sbx' | 'prd'
// Buydot's env is of type 'local' | 'qa' | 'prod'
const getBuydotEnv = (argEnv?: AvaAppEnv): BuydotEnv => {
  const environment = argEnv || AvaAppConfig?.env || appEnv;
  switch (environment) {
    case 'local':
      return 'local';
    case 'dev':
      return 'local';
    case 'qa':
      return 'qa';
    case 'sbx':
      return 'qa';
    case 'prd':
      return 'prod';
    case 'prod':
      return 'prod';
    default:
      return 'qa';
  }
};

// Helper function to get the buydot config based off the env
const getBuydotConfig = (argEnv?: AvaAppEnv) => env[getBuydotEnv(argEnv)];

const conf = getBuydotConfig();

if (window.testEnv === 'e2e') {
  conf.API_URL = E2E_CONSTANTS.API_URL;
  conf.CLIENT_URL = E2E_CONSTANTS.CLIENT_URL;
  conf.BUY_CLIENT_URL = E2E_CONSTANTS.CLIENT_URL;
}

if (window.appEnv === 'prod' && /^https:\/\/staging.buy.avalara.com/.test(window.location.href)) {
  conf.CLIENT_URL = conf.CLIENT_URL.replace('buy.avalara.com', 'staging.buy.avalara.com');
  conf.API_URL = conf.API_URL.replace('buy.avalara.com', 'staging.buy.avalara.com');
}

// Use BUY_CLIENT_URL for links to buy pages specifically, use CLIENT_URL for endpoints that will be
// handled by AvaApp post-migration, e.g. login/logout urls
// In the buy client served by the CIP workload, these two are equivalent
if (AvaAppConfig?.hostnames) {
  const { account, avaApp, avatax, home, identity, integrations, buy } = AvaAppConfig.hostnames;
  conf.AA_URL = account;
  conf.AI_URL = identity;
  conf.API_URL = buy;
  conf.AVATAX_URL = avatax;
  conf.BUY_CLIENT_URL = `${avaApp}/buy`;
  conf.CLIENT_URL = avaApp;
  conf.HOME_URL = home;
  conf.INTEGRATIONS_URL = integrations;
}

conf.ASSET_PATH = AvaAppConfig?.assetsPath || window.assetPath || '';

export default conf;
